import React, { Component } from 'react';
import iosAppImg from "assets/img/iOS_app.png";
import androidAppImg from "assets/img/android_app.png";
import iphone_banner from "assets/img/iphone_banner.png";

class Slider extends Component{

  render(){

    return(

      <section id="main_slider" className="slider_main">
        <div className="container">
          <div className="col-md-8">
            <div className="banner_text_big">It's simple!</div>
            <div className="banner_text_small">MusicAdjudicator.com makes it easy for adjudicators to share their comments with each music director attending with their group at a competitive festival.</div>
            <div className="download_btns">
              <a href="https://itunes.apple.com/us/app/music-adjudicator/id1450253241?ls=1&mt=8" className="download_btn_app" target="_blank">
                <img src={iosAppImg} alt="iosAppImg"/>
              </a>

              <a href="https://play.google.com/store/apps/details?id=com.photovision.musicadjudicator" className="download_btn_app" target="_blank">
                <img src={androidAppImg} height="54" alt="androidAppImg"/>
              </a>
            </div>
          </div>
      
          <div className="col-md-4">
            <img src={iphone_banner} className="img-responsive center_block pull-right banner_img" alt="iphoneBannerImg" />
          </div>
        </div>
        <div className="clearfix"></div>
      </section>
    );
  }
}


export default Slider;


// WEBPACK FOOTER //
// ./src/components/FrontEnd/Header/Slider.jsx